export default "__VITE_ASSET__RH7lrQqq__"